export const logger = {
    debug: (...args) => console.debug('[LIMS]', ...args),
    info: (...args) => console.info('[LIMS]', ...args),
    warn: (...args) => console.warn('[LIMS]', ...args),
    error: (...args) => console.error('[LIMS]', ...args),
};
const noop = () => { };
export const noopLogger = {
    debug: noop,
    info: noop,
    warn: noop,
    error: noop,
};
export default logger;
